export default __webpack_public_path__ + "static/media/MM5B.689782cc.jpg";